import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';
import { getPublicActualite } from '../services/actualiteService';
import { dateLocaleOf, usePublicLocale, usePublicPaths } from '../routes/publicPaths';
import { normalizeStorageUrl } from '../config/apiBase';
import './PublicSimplePages.css';

const ActualiteDetail = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const locale = usePublicLocale();
  const paths = usePublicPaths();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPublicActualite(id)
      .then(setItem)
      .catch(() => setItem(null))
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <div className="public-simple-page">
      <Helmet>
        <title>
          {item?.titre
            ? `${item.titre} | ${t('public.brand.titleSuffix')}`
            : `${t('public.news.itemFallback')} | ${t('public.brand.titleSuffix')}`}
        </title>
      </Helmet>
      <Navbar />
      <main className="public-simple-page__main public-news-article">
        <Link to={paths.actualites} className="public-simple-page__muted">
          ← {t('public.news.all')}
        </Link>
        {loading ? (
          <p className="public-simple-page__muted">{t('common.loading')}</p>
        ) : !item ? (
          <p className="public-simple-page__muted">{t('public.news.missing')}</p>
        ) : (
          <>
            <h1>{item.titre}</h1>
            <p className="public-news-meta">
              {item.date ? new Date(item.date).toLocaleDateString(dateLocaleOf(locale)) : ''}
              {item.categorie ? ` · ${item.categorie}` : ''}
            </p>
            {item.image_url && (
              <img src={normalizeStorageUrl(item.image_url)} alt={item.titre} />
            )}
            <p>{item.description}</p>
          </>
        )}
      </main>
    </div>
  );
};

export default ActualiteDetail;
